import { render } from "./AdditionalInfoStepComponent.vue?vue&type=template&id=eb0339a8&ts=true"
import script from "./AdditionalInfoStepComponent?vue&type=script&lang=ts"
export * from "./AdditionalInfoStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__